import { z } from 'zod';
import { AgentRoleSchema } from '../agents/states.js';
import { TimestampSchema } from '../common/clock.js';
/**
 * Vistas de la consola back-office (`/v1/admin/*`) que publica `services/api` y consume
 * `apps/console`. Las vistas que la consola aún arma localmente (`apps/console/src/api/*-schemas.ts`)
 * se mudan aquí a medida que la API las publica.
 */
/** Tokens de entrada, salida y caché (lectura/escritura). */
export const TokenUsageSchema = z.object({
    input: z.int().min(0),
    output: z.int().min(0),
    cacheRead: z.int().min(0),
    cacheWrite: z.int().min(0),
});
/** `GET /v1/admin/agent/usage`: consumo LLM del día frente a `LLM_DAILY_BUDGET_USD`. */
export const AgentUsageSchema = z
    .object({
    date: z.string(),
    budgetUsd: z.string(),
    userBudgetUsd: z.string(),
    spentUsd: z.string(),
    tokens: TokenUsageSchema,
    /** Fracción de tokens de entrada servidos desde caché (0–1). */
    cacheHitRate: z.string(),
    byRole: z.array(z.object({ role: AgentRoleSchema, calls: z.int(), costUsd: z.string() })),
    byDay: z.array(z.object({ date: z.string(), costUsd: z.string() })),
    costPerApplicationUsd: z.string().nullable(),
    costPerPurchaseUsd: z.string().nullable(),
})
    .meta({ id: 'AgentUsage' });
/** `GET /v1/admin/skills/{code}/versions`: historial de versiones (más reciente primero). */
export const SkillVersionListSchema = z
    .object({
    data: z.array(z.object({
        version: z.int().min(1),
        contentMd: z.string(),
        changeNote: z.string().nullable(),
        createdBy: z.string(),
        createdAt: TimestampSchema,
    })),
})
    .meta({ id: 'SkillVersionList' });
//# sourceMappingURL=index.js.map